var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSort(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 10,
    viewBox: "0 0 9 10",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.90237 2.2643L2.73567 1.09763C2.60567 0.967458 2.39433 0.967458 2.26433 1.09763L1.09763 2.2643C0.967457 2.39447 0.967457 2.60547 1.09763 2.73563C1.22763 2.8658 1.43897 2.8658 1.56897 2.73563L2.16666 2.13796V8.66666C2.16666 8.85067 2.31599 9 2.5 9C2.68401 9 2.83334 8.85067 2.83334 8.66666V2.13796L3.43103 2.73563C3.49603 2.8008 3.58136 2.8333 3.6667 2.8333C3.75203 2.8333 3.83737 2.8008 3.90237 2.73563C4.03254 2.60547 4.03254 2.39447 3.90237 2.2643Z",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.90237 7.26433C7.7722 7.13417 7.5612 7.13417 7.43103 7.26433L6.83334 7.862V1.33333C6.83334 1.14933 6.68401 1 6.5 1C6.31599 1 6.16666 1.14933 6.16666 1.33333V7.862L5.56897 7.26433C5.4388 7.13417 5.22763 7.13417 5.09763 7.26433C4.96746 7.3945 4.96746 7.6055 5.09763 7.73567L6.26433 8.90233C6.3295 8.9675 6.41466 9 6.5 9C6.58534 9 6.6705 8.9675 6.73567 8.90233L7.90237 7.73567C8.03254 7.6055 8.03254 7.3945 7.90237 7.26433Z",
    strokeWidth: 0.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSort);
export default __webpack_public_path__ + "static/media/icon-sort.f84ade148ab2b6ea08dfc8159fb7c1e3.svg";
export { ForwardRef as ReactComponent };